export type UserTier = 'free' | 'pro';

export interface TierLimits {
  maxCaseStudies: number;
  maxPhotos: number;
}

// Fallback defaults only. The backend owns these numbers (backend/config/tierLimits.js) and
// returns the caller's own limits as `limits` on GET /api/auth/me; AuthContext prefers that
// response and falls back to this map before /me has answered. tierLimits.test.ts asserts the
// two match, so a one-sided edit fails the test suite.
//
// Kept in its own module (rather than in api.ts) so the test can import it without pulling in
// axios, which CRA's jest does not transform.
export const TIER_LIMITS: Record<UserTier, TierLimits> = {
  free: { maxCaseStudies: 10, maxPhotos: 3 },
  pro: { maxCaseStudies: 800, maxPhotos: 10 }
};
